export function loadScript(src, callback) {
	const script = document.createElement('script');
	const ref = document.getElementsByTagName('head')[0];

	script.src = src;
	script.async = true;
	script.type = 'text/javascript';

	if (callback) {
		script.onload = callback;
	}

	ref.appendChild(script);
}
/*
	class manipulation functions
*/
export function hasClass(el, className) {
	if (el.classList) {
		return el.classList.contains(className);
	} else {
		return !!el
			.getAttribute('class')
			.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
	}
}

export function addClass(el, className) {
	var classList = className.split(' ');
	if (el.classList) {
		el.classList.add(classList[0]);
	} else if (!hasClass(el, classList[0])) {
		el.setAttribute('class', el.getAttribute('class') + ' ' + classList[0]);
	}
	if (classList.length > 1) {
		addClass(el, classList.slice(1).join(' '));
	}
}

export function removeClass(el, className) {
	var classList = className.split(' ');
	if (el.classList) {
		el.classList.remove(classList[0]);
	} else if (hasClass(el, classList[0])) {
		var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
		el.setAttribute('class', el.getAttribute('class').replace(reg, ' '));
	}
	if (classList.length > 1) removeClass(el, classList.slice(1).join(' '));
}

export function toggleClass(el, className, bool) {
	if (bool) addClass(el, className);
	else removeClass(el, className);
}
